import type { SearchCriteria } from '@/entities/searchCriteria/@/analytics';

export enum MindboxOperation {
  ViewCategory = 'Website.ViewCategory',
}

export type MindboxSerpType = 'main' | 'hot' | 'hotel' | 'railway';

export type MindboxFieldValue = string | number | (string | number)[];

export type MindboxCustomFields = Record<string, MindboxFieldValue>;

export interface MindboxSerpFilters {
  beachType: string | null;
  amenities: string[];
  budgetFrom: number | null;
  budgetTo: number | null;
  closeToSki: boolean;
  exclusive: boolean;
  hotelRating: string | null;
  beachLines: number[];
  ownedBeach: boolean;
  waterActivities: string[];
  childServices: string[];
  tourOperators: string[];
}

export interface MindboxSerpClickSource {
  criteria: SearchCriteria;
  searchCriteria: SearchCriteria;
  filters: MindboxSerpFilters;
}
